var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var actions = require( '../../../modules/conditions/actions/condition');
var conditionsActions = require( '../../../modules/conditions/actions/conditions');
var treatmentClickActions = require( '../../../modules/meta/actions/treatment-click');
var conditionClickActions = require( '../../../modules/meta/actions/condition-click');
var downloadActions = require( '../../../modules/meta/actions/appDownload-click');
var Condition = require('../components/condition.jsx');

  Condition.fetchData = function(query, params, store, history) {
      return Promise.all([
          store.dispatch(conditionsActions.fetchConditionsIfNeeded()),
          store.dispatch(actions.fetchConditionIfNeeded(params.name))
      ]);
  }

  var mapStateToProps = function(state){
    return {
      conditions: state.conditions.items,
      condition: state.selectedCondition,
      featuredPlacement: state.featuredPlacement,
      sponsoredPlacement: state.sponsoredPlacement,
      generic_error: state.common.generic_error
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, actions, conditionsActions, treatmentClickActions, conditionClickActions, downloadActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Condition);



// WEBPACK FOOTER //
// ./src/common/routes/conditions/containers/condition.jsx